<template>
  <div>
    <v-layout row wrap justify-center align-center>
      <v-flex xs11 md11 lg11>
        <v-card class="rounded-lg mt-2">
          <v-card-title class="ml-2" v-if="e1 == 1"
            >{{ $t("NewUpdate.announ1") }}<v-spacer></v-spacer>
            <v-row justify="end">
              <v-col cols="12" sm="12" md="7" lg="7" class="mr-2">
                <v-text-field
                  clearable
                  outlined
                  dense
                  v-model="search"
                  append-icon="mdi-magnify"
                  :label="$t('consentlist.search')"
                  color="#077893"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-title v-if="e1 == 2">
            <v-icon color="#077893" @click="Fn_BackIndex()" size="38">
              mdi-chevron-left
            </v-icon>
            {{ Detail }}
            <!-- {{ Detail.GroupSend }} -->
            <v-spacer></v-spacer>

            <v-btn
              color="#077893"
              class="white--text mr-2"
              :loading="loadCSV"
              @click="Fn_DownloadCSV"
            >
              <v-icon dark> mdi-file-excel-outline </v-icon>
              {{ $t("search.text1") }}
            </v-btn>
          </v-card-title>

          <v-card-text elevation-0>
            <v-card class="elevation-0 pa-2">
              <v-stepper v-model="e1" outlined>
                <v-stepper-items>
                  <v-stepper-content :step="1">
                    <v-data-table
                      :search="search"
                      style="max-height: 400px; overflow: auto"
                      outlined
                      hide-default-footer
                      calculate-widths
                      :headers="headers1"
                      :items="DataGroup"
                      :page.sync="PageConsent"
                      @page-count="PageCountConsent = $event"
                      :items-per-page="ItemPerPageConsent"
                    >
                      <template v-slot:[`item.CreateTH`]="{ item }">
                        <div v-if="$t('default') === 'th'">
                          {{ item.CreateTH }}
                        </div>
                        <div v-else>
                          {{ item.CreateEng }}
                        </div>
                        <div v-if="item.CreateTH == '' || item.CreateEng == ''">
                          -
                        </div>
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-btn
                          outlined
                          dense
                          color="#077893"
                          @click="Fn_GetGroupOneChatSearch(item)"
                          >{{ $t("consentlist.detail") }}</v-btn
                        >
                      </template>
                    </v-data-table>
                    <v-pagination
                      :total-visible="7"
                      class="pt-2 pb-2"
                      circle
                      color="#077893"
                      v-model="PageConsent"
                      :length="PageCountConsent"
                      prev-icon="mdi-menu-left"
                      next-icon="mdi-menu-right"
                    >
                    </v-pagination>
                  </v-stepper-content>
                  <v-stepper-content :step="2">
                    <v-layout row wrap justify-center align-baseline>
                      <v-flex xs12 lg10>
                        <v-flex xs12 lg12>
                          <div id="chart">
                            <center>
                              <apexchart
                                type="pie"
                                width="300"
                                :options="chartOptions"
                                :series="seriesPie"
                              ></apexchart>
                            </center>
                          </div>
                        </v-flex>
                        <v-flex xs12 lg12>
                          <div class="mb-3">
                            <v-icon dense color="indigo">mdi-circle</v-icon>
                            <b v-if="$t('default') === 'th'"> เปิดอ่านแล้ว</b>
                            <b v-else>Open and Read</b> <br />
                            <v-progress-linear
                              :value="(Count.CountRead / Count.CountAll) * 100"
                              color="indigo"
                              height="25"
                            >
                              <strong style="color: #fff"
                                >{{ Math.ceil(Count.CountRead) }}
                                {{ $t("onechat.new5") }}</strong
                              >
                            </v-progress-linear>
                          </div>
                          <div class="mb-3">
                            <v-icon dense color="#fb8c00">mdi-circle</v-icon>
                            <b v-if="$t('default') === 'th'"> รอตอบกลับ</b>
                            <b v-else> Pending</b> <br />
                            <v-progress-linear
                              :value="(Count.CountWait / Count.CountAll) * 100"
                              color="#fb8c00"
                              height="25"
                            >
                              <strong style="color: #fff"
                                >{{ Math.ceil(Count.CountWait) }}
                                {{ $t("onechat.new5") }}</strong
                              >
                            </v-progress-linear>
                          </div>
                          <div class="mb-3">
                            <v-icon dense color="#ff5252">mdi-circle</v-icon>
                            <b v-if="$t('default') === 'th'"> ส่งไม่สำเร็จ</b>
                            <b v-else> Failed</b> <br />
                            <v-progress-linear
                              :value="(Count.CountEr / Count.CountAll) * 100"
                              color="#ff5252"
                              height="25"
                            >
                              <strong style="color: #fff"
                                >{{ Math.ceil(Count.CountEr) }}
                                {{ $t("onechat.new5") }}</strong
                              >
                            </v-progress-linear>
                          </div>
                          <div class="mb-3">
                            <v-icon dense color="#4CAF50">mdi-circle</v-icon>
                            <b v-if="$t('default') === 'th'"> รับทราบ</b>
                            <b v-else> Noted</b> <br />
                            <v-progress-linear
                              :value="(Count.CountOk / Count.CountAll) * 100"
                              color="#4CAF50"
                              height="25"
                            >
                              <strong style="color: #fff"
                                >{{ Math.ceil(Count.CountOk) }}/{{
                                  Math.ceil(Count.CountAll)
                                }}
                                {{ $t("onechat.new5") }}</strong
                              >
                            </v-progress-linear>
                          </div>
                          <!-- {{ Count }} -->
                        </v-flex>
                      </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-container>
                      <v-layout row wrap justify-start align-center>
                        <v-flex xs12 lg12>
                          <div class="my-3">
                            <b v-if="$t('default') === 'th'">รายละเอียด: </b>
                            <b v-else>Detail: </b
                            ><a
                              @click="Fn_DetailPolicy"
                              v-for="(item, i) in Policy"
                              :key="i"
                              class="text-decoration-underline"
                              >{{ item.PolicyHeader }}</a
                            >
                            <br />
                          </div>
                        </v-flex>
                        <!-- <v-flex xs12 lg12>
                          <div class="my-3">
                            <b v-if="$t('default') === 'th'">ความยินยอม: </b>
                            <b v-else>Consent: </b>
                            <div v-for="(item, i) in Consent" :key="i">
                              <a
                                @click="fn_DetailConsent(item)"
                                class="text-decoration-underline"
                                >{{ i + 1 }}. {{ item.ConsentHeader }}
                              </a>
                              <br />
                            </div>
                          </div>
                        </v-flex> -->
                      </v-layout>
                    </v-container>
                    <v-divider></v-divider>
                    <v-container>
                      <v-layout row wrap justify-end>
                        <v-flex xs4 sm4 md3 lg3>
                          <v-select
                            v-if="$t('default') === 'th'"
                            :items="itemsStatus"
                            v-model="valueStatus"
                            outlined
                            rounded
                            dense
                            :label="$t('onechat.statusSearch')"
                          ></v-select>
                          <v-select
                            v-else
                            :items="itemsStatusEng"
                            v-model="valueStatus"
                            outlined
                            rounded
                            dense
                            :label="$t('onechat.statusSearch')"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap justify-center align-center mt-n5>
                        <v-flex xs12 lg12>
                          <v-data-table
                            :search="valueStatus"
                            calculate-widths
                            :headers="headers2"
                            :items="TableConsent"
                            hide-default-footer
                            :page.sync="Page"
                            item-key="AccountId"
                            @page-count="PageCount = $event"
                            :items-per-page="ItemPerPage"
                          >
                            <template v-slot:[`item.SendAt`]="{ item }">
                              <div v-if="$t('default') === 'th'">
                                {{ item.SendAt }}
                              </div>
                              <div v-else>
                                {{ item.SendAtEng }}
                              </div>
                            </template>
                            <template v-slot:[`item.UpdatdeAt`]="{ item }">
                              <div v-if="$t('default') === 'th'">
                                {{ item.UpdatdeAt }}
                              </div>
                              <div v-else>
                                {{ item.UpdatdeAtEng }}
                              </div>
                            </template>
                            <template v-slot:[`item.SendStatus`]="{ item }">
                              <v-chip
                                color="green"
                                dark
                                v-if="item.SendStatus === 'OK'"
                                >{{ $t("onechat.status4") }}</v-chip
                              >
                              <v-chip
                                color="error"
                                dark
                                v-else-if="item.SendStatus === 'ER'"
                                >{{ $t("onechat.status3") }}</v-chip
                              >
                              <v-chip
                                color="warning"
                                dark
                                v-else-if="item.SendStatus === 'WAIT'"
                                >{{ $t("onechat.status7") }}</v-chip
                              >
                              <v-chip
                                color="indigo"
                                dark
                                v-else-if="item.SendStatus === 'Read'"
                                >{{ $t("onechat.status5") }}</v-chip
                              >
                            </template>
                            <template v-slot:[`item.NameTh`]="{ item }">
                              <div v-if="$t('default') === 'th'">
                                {{ item.NameTh }}
                              </div>
                              <div v-else>
                                {{ item.NameEng }}
                              </div>
                            </template>
                            <template v-slot:[`item.Resend`]="{ item }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    color="#077893"
                                    v-on="on"
                                    v-bind="attrs"
                                    :disabled="item.SendStatus === 'OK'"
                                    small
                                    fab
                                    @click="Fn_SendOnechat(item)"
                                  >
                                    <v-icon color="#fff"
                                      >mdi-send-circle-outline</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <span v-if="$t('default') === 'th'"
                                  >{{ $t("onechat.send2") }}ประกาศ</span
                                >
                                <span v-else
                                  >{{ $t("onechat.send2") }}Announce</span
                                >
                              </v-tooltip>
                            </template>
                          </v-data-table>
                          <v-pagination
                            :total-visible="7"
                            class="pt-2 pb-2"
                            circle
                            color="#077893"
                            v-model="Page"
                            :length="PageCount"
                            prev-icon="mdi-menu-left"
                            next-icon="mdi-menu-right"
                          >
                          </v-pagination>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <DialogGeneralConsent
      :show="DialogGeneral"
      :_detail="Policy"
      @closeDialogDelete="DialogGeneral = false"
    />
    <v-dialog v-model="dialogConsent" width="1200" scrollable persistent>
      <v-divider></v-divider>
      <v-card>
        <v-divider></v-divider>
        <br />
        <v-card-text>
          <b>{{ $t("upload.text1") }}: </b>{{ DetailsConsent.ConsentShort }}
          <br />
          <br />
          <v-card color="#ddf7ff">
            <v-card-title>{{ $t("upload.text4") }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div v-html="DetailsConsent.ConsentDetail"></div>
            </v-card-text>
          </v-card>
          <br />
          <v-card color="#ddf7ff">
            <v-card-title>{{ $t("upload.text5") }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div v-html="DetailsConsent.RejectReason"></div>
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" outlined @click="dialogConsent = false">
            {{ $t("upload.text6") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="loadingDownloadData">
      <OverlaySearch />
    </div>
  </div>
</template>

<script>
import DialogGeneralConsent from "@/components/dialog/DialogGeneralDashboardDetail.vue";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  components: { DialogGeneralConsent, OverlaySearch },
  data: (vm) => ({
    num: 2,
    search: "",
    loadingDownloadData: false,
    DataGroup: [],
    Page: 1,
    ItemPerPage: 10,
    PageConsent: 1,
    PageCountConsent: 0,
    ItemPerPageConsent: 10,
    e1: 1,
    Detail: [],
    Count: [],
    CountConsent: [],
    Policy: [],
    Consent: [],
    TableConsent: [],
    PageCount: 0,
    DataConsent: [],
    DialogGeneral: false,
    PolicyHeader: [],
    dialogConsent: false,
    ConsentShort: "",
    ConsentDetail: "",
    RejectReason: "",
    loadCSV: false,
    ConsentDataFile: "",
    TransactionId: "",
    DetailsConsent: [],
    valueStatus: "",
    itemsStatus: [
      { value: "", text: "ทั้งหมด" },
      { value: "OK", text: "รับทราบ" },
      { value: "ER", text: "ส่งไม่สำเร็จ" },
      { value: "WAIT", text: "รอการตอบกลับ" },
      { value: "Read", text: "เปิดอ่านแล้ว" },
    ],
    itemsStatusEng: [
      { value: "", text: "all" },
      { value: "OK", text: "Acknowledged" },
      { value: "ER", text: "Failed" },
      { value: "WAIT", text: "Pending" },
      { value: "Read", text: "Open and Read" },
    ],
    // // tableZone
    series: [],
    seriesPie: [],
    seriesPieCountConsent: [],
    chartOptions: {
      chart: { width: 300, type: "pie" },
      labels: [],
      colors: ["#3f51b5", "#fb8c00", "#ff5252", "#4caf50"],
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: "gradient",
      },
      legend: {
        show: false,
      },
      tooltip: {
        enabled: false,
        theme: "dark",
      },
      responsive: [
        {
          breakpoint: 480,
          options: { chart: { width: 200 }, legend: { position: "bottom" } },
        },
      ],
    },
    chartOptionsCountConsent: {
      chart: { width: 300, type: "pie" },
      labels: [],
      colors: ["#4CAF50", "#F44336", "#FF9800", "#077893"],
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: "gradient",
      },
      legend: {
        show: false,
      },
      tooltip: {
        enabled: false,
        theme: "dark",
      },
      responsive: [
        {
          breakpoint: 480,
          options: { chart: { width: 200 }, legend: { position: "bottom" } },
        },
      ],
    },
  }),
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    headers1() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          align: "center",
          value: "no",
          sortable: false,
        },
        {
          text: this.$i18n.t("NewUpdate.announceId"),
          value: "AnnounceNo",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("NewUpdate.announceName"),
          value: "AnnounceName",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("NewUpdate.totalPer"),
          value: "Total",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("seting.text3"),
          value: "CreateTH",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.detail"),
          value: "action",
          align: "center",
          sortable: false,
        },
      ];
    },
    headers2() {
      return [
        {
          text: this.$i18n.t("dashboard.num"),
          align: "center",
          value: "no",
          sortable: false,
        },
        {
          text: this.$i18n.t("Profile.accountId"),
          align: "left",
          value: "AccountId",
          sortable: false,
        },
        {
          text: this.$i18n.t("onechat.name"),
          value: "NameTh",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("consentlist.date"),
          value: "SendAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("onechat.date"),
          value: "UpdatdeAt",
          align: "center",
          sortable: false,
        },
        {
          text: this.$i18n.t("onechat.status"),
          value: "SendStatus",
          align: "center",
          sortable: false,
        },
        {
          text: "Resend",
          value: "Resend",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  mounted() {
    this.Fn_GetGroupOnechat();
  },
  methods: {
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    Fn_DetailPolicy() {
      this.DialogGeneral = true;
    },
    Fn_BackIndex() {
      this.e1 = 1;
      this.$store.dispatch("SET_DATA_GROUP_ONECHAT", []);
    },
    async Fn_GetGroupOnechat() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/GetAnnounceName",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DataGroup = response.data.Message;
            var startPage =
              this.PageConsent * this.ItemPerPageConsent -
              this.ItemPerPageConsent +
              1;
            var nextPage = startPage + this.DataGroup.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.DataGroup) {
              this.DataGroup[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetGroupOneChatSearch(val) {
      this.Detail = val.AnnounceName;
      this.TransactionId = val.TransactionId;
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        TransactionId: this.TransactionId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "onechat/GetAnnounceNameSearch",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.e1 = 2;
            this.Count = response.data.Message.Count;
            // this.CountConsent = response.data.Message.CountConsent;
            this.Policy = response.data.Message.Policy;
            this.$store.dispatch("SET_DATA_ANNOUNCE", val.AnnounceName);
            this.$store.dispatch(
              "SET_DATA_GROUP_ONECHAT",
              response.data.Message
            );
            // this.Consent = response.data.Message.Detail.Consent;
            this.TableConsent = response.data.Message.Consent;
            var startPage = this.Page * this.ItemPerPage - this.ItemPerPage + 1;
            var nextPage = startPage + this.TableConsent.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.TableConsent) {
              this.TableConsent[j].no = number[j];
            }
            this.seriesPie = [
              this.Count.CountRead,
              this.Count.CountWait,
              this.Count.CountEr,
              this.Count.CountOk,
            ];
            // this.seriesPieCountConsent = [
            //   this.CountConsent.Approve,
            //   this.CountConsent.UnApprove,
            //   this.CountConsent.Balance,
            //   this.CountConsent.CountAll,
            // ];
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_SendOnechat(val) {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccessToken: this.$cookies.get("OneAccessToken"),
        AnnounceId: val.AnnounceId,
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "onechat/OnePlatform/ReSendAnnounce",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            if (response.data.Message[0].SendStatus === "ER") {
              Toast.fire({
                icon: "error",
                title: response.data.Message[0].ErrorMessage,
              });
            } else if (response.data.Message[0].SendStatus === "WAIT") {
              Toast.fire({
                icon: "success",
                title: response.data.Message[0].Message,
              });
            } else {
              Toast.fire({
                icon: "success",
                title: this.$t("NewUpdate.announ5"),
              });
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async fn_DetailConsent(item) {
      this.DetailsConsent = item;
      this.dialogConsent = true;
    },
    async Fn_DownloadCSV() {
      this.loadCSV = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        TransactionId: this.TransactionId,
        Status: "All",
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "report/ExportAnnounce",
          { Data: dataEncode },
          { responseType: "arraybuffer", headers }
        )
        .then((response) => {
          this.loadCSV = false;
          if (response.statusText == "OK") {
            const blob = new Blob([response.data], {
              type: "application/xlsx",
            });
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "Report_Announce" + ".xlsx";
            link.click();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadCSV = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_LinkDownload(url) {
      var link = document.createElement("a");
      link.href = url;
      link.dispatchEvent(new MouseEvent("click"));
    },
  },
  watch: {
    $route(to) {
      document.title = `APPLICATION_NAME - ${to.meta.title}`;
      const link = document.querySelector("[rel='icon']");
      link.setAttribute("href", to.meta.icon);
    },
    valueStatus(val) {
      if (val) {
        var newData = [];
        newData = this.TableConsent.filter((type) => {
          return type.SendStatus === val;
        });
        var index = 0;
        for (var j of newData) {
          j.no = 0;
          index += 1;
          j.no = index;
        }
      } else {
        var indexNone = 0;
        var newDataNone = [];
        newDataNone = this.TableConsent;
        for (var x of newDataNone) {
          x.no = 0;
          indexNone += 1;
          x.no = indexNone;
        }
      }
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
